let Http = require('./http');

module.exports = {
	mixins: [Http],

	props: {
		defaultEndpoint: {
			type: String,
		},
		searchEndpoint: {
			type: String
		},
		initialFilters: {
			type: Object,
			default: function() {
				return {};
			}
		},
	},

	data() {
		return {
			filtersShowing: false,
			filterDefaults: {},
			filterValues: {},
			loadingSearch: true,
			searching: false,
			searchResults : [],
			searchTerm: this.getUrlParam('term'),
			noItemsMessage: 'No Items',
			totalResults: 0, 
			pagination: {}
		}
	},

	computed: {
		showSearchResults() {
			return !this.loadingSearch && !this.searching;
		},

		searchUrl() {
			let url = this.searchEndpoint;

			if(this.searchQuery) {
				url += '?' + this.searchQuery;
			}

			return url;
		},

		searchQuery() {
		   	let str = [];

			if(this.searchTerm) {
				str.push('term=' + encodeURIComponent(this.searchTerm));
			}

		   	Object.keys(this.filterValues).forEach(key => {
		       	if(this.filterValues[key]) {
		       		if(this.filterValues[key] instanceof Array) {
		       			this.filterValues[key].forEach(item => {
		       				if(item) {
								str.push(encodeURIComponent(key) + "[]=" + encodeURIComponent(item));
							}
		       			});
		       		} else if(this.filterValues[key]) {
			           	str.push(encodeURIComponent(key) + "=" + encodeURIComponent(this.filterValues[key]));
			       	}
		       	}
		   	});

		   	return str.join("&");
		}
	},

	watch: {
		searchUrl() {
			this.search();
		}
	},

	created() {
		Object.keys(this.initialFilters).forEach(key => {
			// load initial filter values
			// using Vue.set here to maintain reactivity in nested object properties
			Vue.set(this.filterValues, key, this.initialFilters[key]);

			// setup defaults for filters
			this.filterDefaults[key] = Array.isArray(this.initialFilters[key]) ? [] : 'default';
		});

		this.search();
	},

	mounted() {
		this.filtersShowing = false;
	},

	methods: {
		search() {
			this.searching = true;
			this.sendRequest(this.searchUrl, 'get', this.updateResults);
		},

		updateResults: function(data, message) {
			this.searchResults = data;
			this.searching  = false;
			this.loadingSearch  = false;
		},

		setFilters(filters) {
			Object.assign(this.filterValues, filters);
		},

		resetFilters() {
			Object.assign(this.filterValues, this.filterDefaults);
		},

		showFilters() {
			this.filtersShowing = true;
		},

		hideFilters() {
			this.filtersShowing = false;
		},
		
		toggleFilters() {
			this.filtersShowing = !this.filtersShowing;
		}
	}
}
